import React, { Component } from 'react';
import PropTypes from 'prop-types';

class GifPlaneLoader extends Component {
  render() {
    return (
      <div>
        <img src={'../styles/img/planeLoader_BF.gif'} alt="" />
      </div>
    );
  }
}

GifPlaneLoader.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string
};

export default GifPlaneLoader;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightOptions/gifPlaneLoader/GifPlaneLoader.jsx